import React from 'react';

import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Button from '@marvelapp/marvel-ui/button';
import Link from '@marvelapp/marvel-ui/link';

import assets from 'marketing-website/configs/pages/pricing/support';
import generalStyles from './style/support.module.css';

import Image from '../../components/modules/Image';

export default function Support() {
  return (
    <div className={generalStyles.support}>
      <PageWrap size="l">
        <div className={generalStyles.copy}>
          <h2 className={generalStyles.heading}>Support when you need it</h2>
          <p className={generalStyles.subtitle}>
            If you have questions around pricing, features or anything else, our
            support team is just a few clicks away.
          </p>
          <Link
            url="https://help.marvelapp.com/hc/en-us/requests/new"
            target="_blank"
          >
            <Button size="medium" shape="rounded" hover="blue">
              Chat to us
            </Button>
          </Link>
        </div>
      </PageWrap>
      <div className={generalStyles.container}>
        <div className={generalStyles.imagesHolder}>
          <div className={generalStyles.images}>
            <div>
              <Image {...assets.zorast} hasShadow={false} />
            </div>
            <div>
              <Image {...assets.yav} hasShadow={false} />
            </div>
            <div>
              <Image {...assets.reyElle} hasShadow={false} />
            </div>
            <div>
              <Image {...assets.rua} hasShadow={false} />
            </div>
            <div>
              <Image {...assets.deanFil} hasShadow={false} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/pricing/Support.js